import { render, staticRenderFns } from "./SendDocumentTable.vue?vue&type=template&id=e4aed44c&scoped=true&lang=pug"
import script from "./SendDocumentTable.vue?vue&type=script&lang=ts"
export * from "./SendDocumentTable.vue?vue&type=script&lang=ts"
import style0 from "./SendDocumentTable.vue?vue&type=style&index=0&id=e4aed44c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4aed44c",
  null
  
)

export default component.exports